var getOAuthServerMetadata = function getOAuthServerMetadata(authServerConfig) {
  var baseUrl = authServerConfig.url;
  return {
    issuer: baseUrl,
    authorizationEndpoint: "".concat(baseUrl, "/oauth2/v2/auth"),
    tokenEndpoint: "".concat(baseUrl, "/api/token"),
    jwksUrl: "".concat(baseUrl, "/oidc/certs/v1")
  };
};

export default getOAuthServerMetadata;